export type variant = 'payg' | 'growth' | 'custom';

const PlanCheckmark = ({ variant }: { variant: variant }) => {
  const strokeId = `plan_checkmark_${variant}_stroke_color`;
  let startColor = '#0BA299';
  let endColor = '#29A20B';

  if (variant === 'growth') {
    startColor = '#D45AED';
    endColor = '#F8626E';
  } else if (variant === 'custom') {
    startColor = '#00A2C2';
    endColor = '#0BA299';
  }

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='27'
      height='25'
      viewBox='0 0 27 25'
      fill='none'
    >
      <path
        d='M3 13.4218L9.82438 21.1184L24.3262 2.83887'
        stroke={`url(#${strokeId})`}
        stroke-width='4.22609'
        stroke-linecap='round'
      />
      <defs>
        <linearGradient
          id={strokeId}
          x1='3'
          y1='21.1184'
          x2='22.1683'
          y2='0.802844'
          gradientUnits='userSpaceOnUse'
        >
          <stop stop-color={startColor} />
          <stop offset='1' stop-color={endColor} />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default PlanCheckmark;
